import React from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';
import { css } from 'styled-components/macro'; //eslint-disable-line

import Header, {
  NavLink,
  NavLinks,
  PrimaryLink,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from '../headers/light.js';

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
const Container = styled.div`
  ${tw`relative  -mt-8 bg-center bg-cover`}
  background-image: url("https://images.unsplash.com/photo-1522071901873-411886a10004?ixlib=rb-1.2.1&auto=format&fit=crop&w=1920&q=80");
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-500 opacity-25`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-500 px-2 -mx-4 py-2`}
  &::before {
    content: '';
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 text-primary-500 font-bold rounded shadow transition duration-300 hocus:bg-primary-500 hocus:text-gray-100 focus:shadow-outline`;

export default () => {
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href='#about'>Acerca</NavLink>
      <NavLink href='#services'>Servicios</NavLink>
      <NavLink href='#team'>Equipo</NavLink>
      <NavLink href='#faqs'>FAQ</NavLink>
      <NavLink
        href='https://chat.madritech.co/hc/tratamiento-datos/articles/1748636674-politica-de-privacidad'
        target='_blank'
        rel='noopener noreferrer'
      >
        Política de Privacidad
      </NavLink>
      <NavLink
        href='https://chat.madritech.co/hc/tratamiento-datos/articles/1748900711-condiciones-de-servicio'
        target='_blank'
        rel='noopener noreferrer'
      >
        Condiciones del Servicio
      </NavLink>
    </NavLinks>,
    <NavLinks key={2}>
      <PrimaryLink href='#contact'>Contáctanos</PrimaryLink>
    </NavLinks>,
  ];

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <TwoColumn>
          <LeftColumn>
            <Notification>
              Transformando organizaciones en Colombia.
            </Notification>
            <Heading>
              <span>Soluciones tecnológicas integrales</span>
              <br />
              <SlantedBackground>Sector público y privado.</SlantedBackground>
            </Heading>
            <p tw='mt-6 text-lg text-gray-100 max-w-md'>
              Impulsamos la transformación digital con un equipo joven y
              experimentado, creando productos SaaS rentables y escalables,
              adaptados a las necesidades de cada cliente.
            </p>
            <PrimaryAction>Conoce nuestra misión</PrimaryAction>
          </LeftColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
